// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Insights_insights__container__nHS5K {
  background: var(--color-surface);
  padding: var(--gutter);
}
.Insights_insights__grid__nGW1\\+ {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: var(--gutter);
}
.Insights_insights__card__btszb {
  background: var(--color-surface-light);
  border-radius: var(--radius-card);
  display: flex;
  flex-direction: column;
  height: 500px;
  overflow: hidden;
}
.Insights_insights__card--experts__\\+Aevz, .Insights_insights__card--full__sA6-8 {
  grid-column: 1/-1;
  height: unset;
}
.Insights_insights__card-title__jcnIy {
  font-size: var(--font-size-larger);
  color: var(--color-text);
}
.Insights_insights__card-header__vup9H {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--gutter);
  border-bottom: 1px solid var(--color-border);
  background-color: var(--color-surface-light);
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
  height: 4rem;
}
.Insights_insights__card-content__Yco3x {
  display: flex;
  flex-direction: column;
  gap: calc(var(--gutter) / 4);
  padding: calc(var(--gutter) / var(--golden-ratio)) var(--gutter);
  flex-grow: 1;
  overflow-y: auto;
  scrollbar-width: thin;
}
.Insights_insights__card-content__Yco3x::-webkit-scrollbar {
  width: 6px;
}
.Insights_insights__card-content__Yco3x::-webkit-scrollbar-track {
  background: transparent;
}
.Insights_insights__card-content__Yco3x::-webkit-scrollbar-thumb {
  background-color: var(--color-border);
  border-radius: 3px;
}
.Insights_insights__metric-selector__Tjnhy {
  width: 120px;
}
.Insights_insights__card-controls__g93SN {
  display: flex;
  align-items: center;
  gap: var(--gutter);
  flex-wrap: wrap;
}
.Insights_insights__skill-list__Fylfq {
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
  padding: var(--gutter);
}
.Insights_insights__skill-item__USSNr {
  display: flex;
  align-items: center;
  gap: var(--gutter);
  padding: var(--gutter) calc(var(--gutter) / var(--golden-ratio)) var(--gutter) 0;
}
.Insights_insights__skill-item__USSNr:not(:last-child) {
  border-bottom: 1px solid var(--color-border);
}
.Insights_insights__skill-item__rank__Wu1PV {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: var(--radius-default);
  background: var(--color-surface);
  color: var(--color-text);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}
.Insights_insights__skill-item__info__uouOv {
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1 1;
}
.Insights_insights__skill-item__title__97-qO {
  font-weight: 500;
}
.Insights_insights__skill-item__group__GdnIG {
  font-size: var(--font-size-smaller);
  line-height: var(--font-size-smaller);
  color: var(--color-text-subtle);
}
.Insights_insights__skill-item__no-members__U4t1G {
  font-weight: bold;
  color: var(--color-destructive);
}
.Insights_insights__skill-item__focus__MIgqS {
  color: var(--color-primary);
}
.Insights_insights__skill-item__score__AERac {
  min-width: 50px;
  display: flex;
  justify-content: flex-end;
}
.Insights_insights__skill-item__score-text__WQ0J\\+ {
  font-weight: 600;
  color: var(--color-text);
}

@media (max-width: 1200px) {
  .Insights_insights__grid__nGW1\\+ {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .Insights_insights__grid__nGW1\\+ {
    grid-template-columns: 1fr;
  }
  .Insights_insights__card-header__vup9H {
    flex-direction: row;
    align-items: center;
    gap: calc(var(--gutter) / 2);
  }
  .Insights_insights__card__btszb {
    height: unset;
  }
}
.Insights_expert-group__Q5rBy {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: var(--gutter);
}
.Insights_expert-group__title__OgVWs {
  color: var(--color-text);
  font-weight: 600;
  padding: var(--gutter);
  background: var(--color-surface);
}

.Insights_expert-item__\\+Izg9 {
  border-radius: var(--radius-default);
  padding: var(--gutter);
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  gap: calc(var(--gutter) / 2);
}
.Insights_expert-item__title__9SCMZ {
  font-weight: 600;
}
.Insights_expert-item__members__89Tcl {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: calc(var(--gutter) / 4);
}

.Insights_no-data-message__P-UVq {
  padding: var(--gutter);
  color: var(--color-text-subtle);
  font-style: italic;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/views/Insights.module.scss"],"names":[],"mappings":"AACE;EACE,gCAAA;EACA,sBAAA;AAAJ;AAGE;EACE,aAAA;EACA,kCAAA;EACA,kBAAA;AADJ;AAIE;EACE,sCAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAFJ;AAII;EAEE,iBAAA;EACA,aAAA;AAHN;AAOE;EACE,kCAAA;EACA,wBAAA;AALJ;AAQE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,4CAAA;EACA,4CAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,gEAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAPJ;AASI;EACE,UAAA;AAPN;AAUI;EACE,uBAAA;AARN;AAWI;EACE,qCAAA;EACA,kBAAA;AATN;AAaE;EACE,YAAA;AAXJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAZJ;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gFAAA;AAfJ;AAgBI;EACE,4CAAA;AAdN;AAiBI;EACE,aAAA;EACA,cAAA;EACA,oCAAA;EACA,gCAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;AAfN;AAkBI;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,SAAA;AAhBN;AAmBI;EACE,gBAAA;AAjBN;AAoBI;EACE,mCAAA;EACA,qCAAA;EACA,+BAAA;AAlBN;AAqBI;EACE,iBAAA;EACA,+BAAA;AAnBN;AAsBI;EACE,2BAAA;AApBN;AAuBI;EACE,eAAA;EACA,aAAA;EACA,yBAAA;AArBN;AAwBI;EACE,gBAAA;EACA,wBAAA;AAtBN;;AA4BA;EAEI;IACE,8BAAA;EA1BJ;AACF;AA8BA;EAEI;IACE,0BAAA;EA7BJ;EAgCE;IACE,mBAAA;IACA,mBAAA;IACA,4BAAA;EA9BJ;EAiCE;IACE,aAAA;EA/BJ;AACF;AAsCA;EACE,aAAA;EACA,4DAAA;EACA,kBAAA;AApCF;AAsCE;EACE,wBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gCAAA;AApCJ;;AAwCA;EACE,oCAAA;EACA,sBAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;AArCF;AAuCE;EACE,gBAAA;AArCJ;AAwCE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,4BAAA;AAtCJ;;AA0CA;EACE,sBAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;AAvCF","sourcesContent":[".insights {\n  &__container {\n    background: var(--color-surface);\n    padding: var(--gutter);\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: var(--gutter);\n  }\n\n  &__card {\n    background: var(--color-surface-light);\n    border-radius: var(--radius-card);\n    display: flex;\n    flex-direction: column;\n    height: 500px;\n    overflow: hidden;\n\n    &--experts,\n    &--full {\n      grid-column: 1 / -1;\n      height: unset;\n    }\n  }\n\n  &__card-title {\n    font-size: var(--font-size-larger);\n    color: var(--color-text);\n  }\n\n  &__card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: var(--gutter);\n    border-bottom: 1px solid var(--color-border);\n    background-color: var(--color-surface-light);\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    flex-shrink: 0;\n    height: 4rem;\n  }\n\n  &__card-content {\n    display: flex;\n    flex-direction: column;\n    gap: calc(var(--gutter) / 4);\n    padding: calc(var(--gutter) / var(--golden-ratio)) var(--gutter);\n    flex-grow: 1;\n    overflow-y: auto;\n    scrollbar-width: thin;\n\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: var(--color-border);\n      border-radius: 3px;\n    }\n  }\n\n  &__metric-selector {\n    width: 120px;\n  }\n\n  &__card-controls {\n    display: flex;\n    align-items: center;\n    gap: var(--gutter);\n    flex-wrap: wrap;\n  }\n\n  // Skill List Styles\n  &__skill-list {\n    display: flex;\n    flex-direction: column;\n    gap: var(--gutter);\n    padding: var(--gutter);\n  }\n\n  &__skill-item {\n    display: flex;\n    align-items: center;\n    gap: var(--gutter);\n    padding: var(--gutter) calc(var(--gutter) / var(--golden-ratio)) var(--gutter) 0;\n    &:not(:last-child) {\n      border-bottom: 1px solid var(--color-border);\n    }\n\n    &__rank {\n      width: 1.5rem;\n      height: 1.5rem;\n      border-radius: var(--radius-default);\n      background: var(--color-surface);\n      color: var(--color-text);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: bold;\n      flex-shrink: 0;\n    }\n\n    &__info {\n      display: flex;\n      flex-direction: column;\n      gap: 0;\n      flex: 1;\n    }\n\n    &__title {\n      font-weight: 500;\n    }\n\n    &__group {\n      font-size: var(--font-size-smaller);\n      line-height: var(--font-size-smaller);\n      color: var(--color-text-subtle);\n    }\n\n    &__no-members {\n      font-weight: bold;\n      color: var(--color-destructive);\n    }\n\n    &__focus {\n      color: var(--color-primary);\n    }\n\n    &__score {\n      min-width: 50px;\n      display: flex;\n      justify-content: flex-end;\n    }\n\n    &__score-text {\n      font-weight: 600;\n      color: var(--color-text);\n    }\n  }\n}\n\n// Media query for smaller screens\n@media (max-width: 1200px) {\n  .insights {\n    &__grid {\n      grid-template-columns: 1fr 1fr;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .insights {\n    &__grid {\n      grid-template-columns: 1fr;\n    }\n\n    &__card-header {\n      flex-direction: row;\n      align-items: center;\n      gap: calc(var(--gutter)/2);\n    }\n\n    &__card {\n      height: unset;\n    }\n  }\n}\n\n\n\n// Expert Section Styles\n.expert-group {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: var(--gutter);\n\n  &__title {\n    color: var(--color-text);\n    font-weight: 600;\n    padding: var(--gutter);\n    background: var(--color-surface);\n  }\n}\n\n.expert-item {\n  border-radius: var(--radius-default);\n  padding: var(--gutter);\n  background: var(--color-surface);\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--gutter)/2);\n\n  &__title {\n    font-weight: 600;\n  }\n\n  &__members {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: calc(var(--gutter) / 4);\n  }\n}\n\n.no-data-message {\n  padding: var(--gutter);\n  color: var(--color-text-subtle);\n  font-style: italic;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"insights__container": `Insights_insights__container__nHS5K`,
	"insights__grid": `Insights_insights__grid__nGW1+`,
	"insights__card": `Insights_insights__card__btszb`,
	"insights__card--experts": `Insights_insights__card--experts__+Aevz`,
	"insights__card--full": `Insights_insights__card--full__sA6-8`,
	"insights__card-title": `Insights_insights__card-title__jcnIy`,
	"insights__card-header": `Insights_insights__card-header__vup9H`,
	"insights__card-content": `Insights_insights__card-content__Yco3x`,
	"insights__metric-selector": `Insights_insights__metric-selector__Tjnhy`,
	"insights__card-controls": `Insights_insights__card-controls__g93SN`,
	"insights__skill-list": `Insights_insights__skill-list__Fylfq`,
	"insights__skill-item": `Insights_insights__skill-item__USSNr`,
	"insights__skill-item__rank": `Insights_insights__skill-item__rank__Wu1PV`,
	"insights__skill-item__info": `Insights_insights__skill-item__info__uouOv`,
	"insights__skill-item__title": `Insights_insights__skill-item__title__97-qO`,
	"insights__skill-item__group": `Insights_insights__skill-item__group__GdnIG`,
	"insights__skill-item__no-members": `Insights_insights__skill-item__no-members__U4t1G`,
	"insights__skill-item__focus": `Insights_insights__skill-item__focus__MIgqS`,
	"insights__skill-item__score": `Insights_insights__skill-item__score__AERac`,
	"insights__skill-item__score-text": `Insights_insights__skill-item__score-text__WQ0J+`,
	"expert-group": `Insights_expert-group__Q5rBy`,
	"expert-group__title": `Insights_expert-group__title__OgVWs`,
	"expert-item": `Insights_expert-item__+Izg9`,
	"expert-item__title": `Insights_expert-item__title__9SCMZ`,
	"expert-item__members": `Insights_expert-item__members__89Tcl`,
	"no-data-message": `Insights_no-data-message__P-UVq`
};
export default ___CSS_LOADER_EXPORT___;
